import { LabelsContext } from "helpers/contexts";
import React, { useContext, useEffect, useState } from "react";
import DesktopCreatingScreen from "./DesktopCreatingScreen";
import MobileCreatingScreen from "./MobileCreatingScreen";

function CreatingScreen(props) {
  const { signUp } = useContext(LabelsContext);
  const [secondaryHeadline, setSecondaryHeadline] = useState(
    signUp.creatingScreen.sitTight
  );
  const headlines = [
    signUp.creatingScreen.sitTight,
    signUp.creatingScreen.dashboards,
    signUp.creatingScreen.workflows,
  ];

  useEffect(() => {
    handleSecondaryHeadline(1);
    handleCreateUser();
  }, []);

  const handleSecondaryHeadline = (index) => {
    if (index < headlines.length) {
      setSecondaryHeadline(headlines[index]);
      setTimeout(() => handleSecondaryHeadline(index + 1), 2000);
    } else {
      setTimeout(() => handleSecondaryHeadline(0), 1000);
    }
  };
  const handleCreateUser = () => {
    props.onCreateUser && props.onCreateUser();
  };

  const sharedProps = {
    headline: signUp.creatingScreen.almostThere,
    secondaryHeadline: secondaryHeadline,
  };

  return props.isMobileMode || props.isTabletBreakpoint ? (
    <MobileCreatingScreen {...sharedProps} />
  ) : (
    <DesktopCreatingScreen {...sharedProps} />
  );
}

export default CreatingScreen;
